import { hot } from 'react-hot-loader';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from 'react-router-dom/es/withRouter';
import { withCookies, Cookies } from 'react-cookie';
import PropTypes from 'prop-types';
import _ from 'lodash';
import qs from 'qs';
import DocumentTitle from 'utils/DocumentTitle';

import {
  selectUserId,
  selectHasAuthorized,
  sendGetAuthAccountDataRequest
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import {
  sendRequest as sendRequestGetReferenceLists,
  selectRequestState as selectRequestStateReferenceLists
} from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';

import {
  sendRequest as sendRequestGetCounts,
  selectRequestState as selectRequestStateCounts
} from 'mt-react-common/modules/main/reducers/static/states/counts/reducer';

import { Route, Switch } from 'react-router-dom';
import UserService from 'mt-react-common/modules/users/services/UserService';

import LayoutApp from './lauoyts/LayoutApp/index';
import LayoutLandingPage from './lauoyts/LayoutLandingPage/index';
import Sandbox from './lauoyts/Sandbox/index';

import Notifications from './components/Notifications/Notifications';
import BigPreLoader from './components/Common/PreLoaders/BigPreLoader';

import Confirm from './lauoyts/Common/Confirm';

import { AUTH_KEY_CONST } from './constants/LocalStorage';

class App extends Component {
  constructor(props) {
    super(props);
    this.props.sendGetAuthAccountDataRequest();
    this.props.sendRequestGetReferenceLists();
    this.props.sendRequestGetCounts();

    // Сохраняем id реферера в cookies если есть
    const refId = _.get(qs.parse(this.props.location.search.slice(1)), 'ref');
    if (refId) {
      const date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      this.props.cookies.set('ref', refId, { path: '/', expires: date });
    }
  }

  componentWillUpdate(nextProps) {
    // Если куки авторизации не актуальны удаляем их
    if (
      nextProps.hasAuthorized === false &&
      this.props.hasAuthorized === null &&
      this.props.cookies.get(AUTH_KEY_CONST)
    ) {
      this.props.cookies.remove(AUTH_KEY_CONST, { path: '/' });
    }

    /**
     * Если production и пользователь не авторизирован, перенаправляем в корень домена на котором
     * php лендинг с авторизацией
     */
    if (
      nextProps.hasAuthorized === false &&
      this.props.hasAuthorized === null &&
      // eslint-disable-next-line dot-notation
      process.env['ENV_TYPE'] === 'production' &&
      window.location.pathname !== '/'
    ) {
      window.location.href = '/';
    }
  }

  componentDidUpdate(prevProps) {
    // Сохраняем uid метрик пользователя
    if (this.props.authUserId !== prevProps.authUserId) {
      const gaUid =
        this.props.cookies.get('_ga') || this.props.cookies.get('_gid') || null;
      const ymUid = this.props.cookies.get('_ym_uid') || null;
      UserService.saveMetricsUid(this.props.authUserId, gaUid, ymUid).catch();
    }
  }

  render() {
    if (
      this.props.hasAuthorized === null ||
      this.props.requestStateReferenceLists.hasInProgress ||
      this.props.requestStateCounts.hasInProgress
    ) {
      return <BigPreLoader />;
    }
    return (
      <DocumentTitle title="TaskPay">
        <React.Fragment>
          <Notifications />
          <Switch>
            <Route path="/sandbox" component={Sandbox} />
            <Route path="/confirm" component={Confirm} />
            <Route path="/info" component={LayoutLandingPage} />
            {/* <Route path="/help" component={LayoutLandingPage} /> */}
            <Route path="/spec" component={LayoutLandingPage} />
            ListItemLink
            <Route
              path="/account/reset-password"
              component={LayoutLandingPage}
            />
            <Route
              path="*"
              exact
              render={() => {
                if (
                  this.props.hasAuthorized === false &&
                  // eslint-disable-next-line dot-notation
                  process.env['ENV_TYPE'] !== 'production'
                ) {
                  return <LayoutLandingPage />;
                } else if (
                  this.props.requestStateReferenceLists.hasSuccessQuery &&
                  this.props.requestStateCounts.hasSuccessQuery
                ) {
                  return <LayoutApp />;
                }
                return null;
              }}
            />
          </Switch>
        </React.Fragment>
      </DocumentTitle>
    );
  }
}

App.defaultProps = {
  hasAuthorized: null,
  authUserId: null
};

App.propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired,

  authUserId: PropTypes.number,
  hasAuthorized: PropTypes.bool,
  requestStateReferenceLists: PropTypes.shape({
    hasInProgress: PropTypes.bool,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  requestStateCounts: PropTypes.shape({
    hasInProgress: PropTypes.bool,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  sendGetAuthAccountDataRequest: PropTypes.func.isRequired,
  sendRequestGetReferenceLists: PropTypes.func.isRequired,
  sendRequestGetCounts: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  hasAuthorized: selectHasAuthorized(state),
  authUserId: selectUserId(state),
  requestStateReferenceLists: selectRequestStateReferenceLists(state),
  requestStateCounts: selectRequestStateCounts(state)
});

const mapDispatchToProps = dispatch => ({
  sendGetAuthAccountDataRequest: () =>
    dispatch(sendGetAuthAccountDataRequest()),
  sendRequestGetReferenceLists: () => dispatch(sendRequestGetReferenceLists()),
  sendRequestGetCounts: () => dispatch(sendRequestGetCounts())
});

export default withCookies(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(hot(module)(App))
  )
);



// WEBPACK FOOTER //
// ./src/App.js